import MisalignmentPill from "PFApp/components/pills/misalignment_pill";
import React from "react";

import css from "../bars.module.scss";
import BasicBar from "../basic_bar";

interface IProps {
  left: number;
  top?: number;
  width: number;
}

const MisalignmentBar = ({ left, top, width }: IProps) => (
  <BasicBar left={left} top={top} width={width} className={css.misalignmentBar}>
    <MisalignmentPill />
  </BasicBar>
);

export default MisalignmentBar;
